
<template>

  <Modal @close="closeModale">
    <template #header>
     برداشت تومان
    </template>
    <template #body >
      <div class="body">
        <div class="points">
          <div class="point">
            <img class="icon" src="../../../assets/icon/caution.svg"/>
            <div>درخواست های تسویه ریالی در روزهای تعطیل به دلیل تعطیلی بانک ها و عدم فعالیت سیستم پایا انجام نمی شود.</div>
          </div>
          <div class="point">
            <img class="icon" src="../../../assets/icon/caution.svg"/>
            <div>درخواست های تسویه بالای 100 میلیون تومان به دلیل محدودیت های بانکی حداکثر تا یک روز آینده کاری از زمان ثبت درخواست انجام خواهدشد.</div>
          </div>

        </div>
        <div class="depsoit"><div class="depsoit-label">موجودی  </div> <div class="depsoit-value" >{{$toLocal(cash,$decimal["TOMAN"])}} TMN</div></div>

        <div class="inputs-container">
          <label-input  label=" میزان برداشت " @value="value=> amount=value" />
        <div class="inputs-container">


                 <div class="dropdown">
          <div
            
            @click.prevent="openDropdown = !openDropdown"
            id="openDrop"
          >
            <span> {{ select }}</span>
          </div>
          <label for="openDrop">

          </label>
          <div class="list" v-if="openDropdown">
            <div
              v-for="(Bank,index) in Banks" :key="index" 
              @click.prevent="selectItems(index)"
            >
              <p>{{ Bank.cardNumber }}</p>
            </div>
          </div>
        </div>
        </div>
          <label-input  label=" شناسه دوعاملی "  v-if="continu"
          @value="value=> TwoStep_code=value" />
   
        </div>
            <button v-if="!continu" class="cont" @click="withdraw" :disabled="!!disabled">
          {{!!disabled? disabled : 'ادامه'}}
        </button>
        <button v-if="continu&&countDown!==0" class="submit" @click="submitWithdrawRequest" >
          ثبت
        </button>
                    <button v-if="countDown===0" class="submit" @click="withdraw;closeModal" :disabled="!!disabled">
                ارسال  مجدد
            </button>
      </div>

    </template>
  </Modal>

</template>

<script>
import Modal from './Modal'
export default {
  name: 'CryptoDepsoit',
  components:{
    Modal
  },

  props:{
  },
  data(){
    return{
      depsoit:877273497,
       closeIt: true,
      continu: false,
      submit: false,
      success: false,
      select: "",
      openDropdown: false,
      banksOptions: false,
      unit: "تومان",
      countDown:120,
      timeOut:'',
      Banks: [],
        amount:0,
      role:{},
      cash:0,
      walletAddress: "",
      submitBTN: false,
      sendBTN: false,
      TwoStep_code: "",
      transaction: {
        code: this.TwoStep_code,
      },
      BankCart: [
        {
          cardNumber: "۵۸۹۲۱۰۱۱۵۹۰۳۰۷۸۸",
        },
        {
          cardNumber: "۶۱۰۴۳۳۷۷۶۲۳۴۵۲۰۱",
        },
        {
          cardNumber: "۵۸۹۲۱۰۱۱۵۹۰۳۰۷۸۸",
        },
        {
          cardNumber: "۱۲۴۵۱۲۳۶۵۴۱۲۳۶۵۴",
        },
      ],
    }
  },
  computed: { 
    disabled() {
let Error =''

if(!this.$S2N(this.amount)){
  Error ='مبلغ وارد شده صحیح نیست'
}
else if(this.$S2N(this.amount) > this.$S2N(this.cash) ){
  Error ="مبلغ وارد شده بیشتر از موجودی کیف پول شما می باشد"
}

else if (this.$S2N(this.amount) > this.$S2N(this.max)){
Error = "مبلغ وارد شده بیشتر از حداکثر برداشتی است"
}
else if (this.$S2N(this.amount) < this.$S2N(this.min)){
Error = "مبلغ وارد شده کمتر از حداقل برداشتی است"
}
else if(!this.walletAddress){
Error = "آدرس کیف پول وارد نشده است"
}

      // return (
      //   !this.$S2N(this.amount) ||
      //   this.$S2N(this.amount) > this.$S2N(this.cash) ||
      //   this.$S2N(this.amount) > this.$S2N(this.max) ||
      //   this.$S2N(this.amount) < this.$S2N(this.min) ||
      //    !this.walletAddress 
      // );
      return Error
    },
    min() {
      return this.role.minWithdrawAmount;
    },
    max() {
      return this.role.maxWithdrawAmount;
    },
    danger() {
      return (
        "حداقل " +
        this.$toLocal(this.min) +
        " تومان" +
        "\n" +
        "حداکثر " +
        this.$toLocal(this.max) +
        " تومان"
      );
    },
  },
  methods: {
       countDownTimer() {
      this.continu=true;
      if (this.countDown > 0) {
        this.timeOut = setTimeout(() => {
          this.countDown--;
          this.countDownTimer();
        }, 1000);
      } else {
        this.$error("زمان شما به اتمام رسید", "");
        
      }
    },
    closeModale() {
      this.$emit("closeModal");
    },
    logOut() {
      this.$logout();
      // this.$router.push('/login')
    },
    selectItems(index) {
      this.select = this.Banks[index].cardNumber;
      this.openDropdown = false;
    },
    async getData() {
      this.state.loading = true;
      const res = await this.$axios.get("/users/verified-bank-accounts");
      this.Banks = res.content;
    },
        async getInventory(){
      this.state.loading = true;
      let res = await this.$axios('/wallets/customer-addresses?walletType=P2P')
      this.cash = res["TOMAN"].credit
 
    },
                 async getDataCoins() {
            this.state.loading = true
            const res = await this.$axios.get('/coins/details')
            this.coins = res.content
            this.role = this.coins.find((a) => a.coin === "TOMAN")

        },
    async withdraw() {
      this.state.loading = true;
      this.countDown = 120
      const res = await this.$axios.post("/users/send-code");
      if (res.message === "code sent successfully.") {
        this.sendBTN = true;
        this.continu=true
        this.countDownTimer();
        // this.$emit(
        //     "two-fa",
        //     [transaction, res.baseDTO.towStepAuthenticationType]
        // );
      }
    },
    async submitWithdrawRequest() {
      //  this.closemodale();
      this.state.loading = true;
      this.transaction.amount = this.$S2N(this.amount);
      this.transaction.destinationWalletAddress = this.walletAddress;
      this.transaction.relatedCoin = "TOMAN";
      this.transaction.code = this.TwoStep_code;
      const [res] = await this.$http.post(
        `/wallets/withdrawal-request`,
        this.transaction
      );
      if (res) {
        this.closeModale();
        this.$error("درخواست برداشت شما با موفقیت ثبت شد", "", "success");
        ++this.state.requestChanged;
        
      }
    },
  },
    async mounted() {
       this.getDataCoins()
    this.getInventory()
    await this.getData()
    this.select = this.Banks[0].cardNumber
       this.walletAddress = this.select
  },
  beforeDestroy() {
  clearTimeout(this.timeOut)
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.inputs-container{
display: flex;
flex-direction: column;
position: relative;
}
.list{
  display: flex;
  flex-direction: column;
  // gap:10px;
  position: absolute;
  top: 50px;
  z-index: 10;
  width: 100%;
  background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
    box-shadow: 0px 4px 24px -1px rgb(0 0 0 / 25%);
    left:0;
    right:0;
}
.dropdown{
  border: 1px solid #D7C8C8;
    box-sizing: border-box;
    border-radius: 4px;
    height: 52px;
    display: flex;
    align-items: center;
    padding: 10px;
}

.inventory{
  font-size:clamp(10px,1vw,12px);
  display: flex;
  align-items: center;
}
.inputs-container{
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  // margin-top:40px;
}


.depsoit{
  color: #D7C8C8;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 15px;

}

.points{
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  margin-top: 40px;
}
.depsoit-value{
  display: flex;
  column-gap: 5px;
  direction: ltr;
  font-size: clamp(11px,1.2vw,12px);
  cursor: pointer;
}
.depsoit-label{
  font-size: clamp(9px,1vw,10px);
}
.body{
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}
.inputs-container{
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}
.point{
  display: flex;
  column-gap: 5px;
  align-items: flex-start;
  color: #FBFBFD;
  font-size: clamp(12px,1.2vw,14px);
}
.body{
  display: flex;
  flex-direction: column;
  row-gap: 30px;
}
button{
  background: linear-gradient(181.54deg, #1199FA 1.31%, #123249 180.79%);
  border-radius: 4px;
  width: 100%;
  color: white;
  padding: 8px 0;
}

</style>
